import React from 'react'
import { Drawer, Typography,Box, styled } from '@mui/material'
import { ArrowBack } from '@mui/icons-material'
import Profile from './Profile'




const drawerStyle={
    left:20,
    top:17,
    height:'95%',
    width:"30%",
    boxShadow:"none"

}

const Text=styled(Typography)`
font-sixe:18px
`
const Headers=styled(Box)`
background:#008069;
height:107px;
color:#FFFFFF;
display:flex;
& > svg, &>p{
   margin-top:auto;
   padding:15px;
   font-weight:600;

}
`
const Components=styled(Box)`
background:#ededed;
height:85%
`





function Infodrawer({ open, setOpen }) {


    const toggleDrawer=()=>{
        setOpen(false)
    }

 

    return (
        <div>
            <Drawer
                
                open={open}
                onClose={toggleDrawer}
                PaperProps={{sx:drawerStyle}}
                style={{zIndex:'1500'}}
            >

               <Headers>
               <ArrowBack onClick={()=>setOpen(false)}/>
                <Text>Profile</Text>
               </Headers>
               <Components>
                 <Profile/>
               </Components>
               
            </Drawer>
        </div>
    )
}

export default Infodrawer
